import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface StopsIconProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function StopsIcon({ isSelected = false, isHover = false, style = {}, ...props }: StopsIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" style={{ width: `20px`, height: `20px`, ...style }}>
      <g>
        <path
          d="M17.6103 4.47995C17.1903 3.61995 16.5903 2.85995 15.8303 2.19995C15.0603 1.53995 14.1603 1.02995 13.1603 0.679954C12.1503 0.319954 11.0903 0.139954 10.0003 0.139954C7.80025 0.139954 5.73025 0.869954 4.17025 2.19995C2.62025 3.52995 1.76025 5.28995 1.76025 7.15995C1.76025 9.89995 3.02025 12.81 5.52025 15.8C6.31025 16.74 7.62025 18.18 9.43025 19.64L9.52025 19.71C9.66025 19.81 9.83025 19.86 10.0103 19.86C10.1903 19.86 10.3403 19.81 10.5203 19.69C10.5203 19.69 12.5303 18.19 14.5103 15.81C16.9603 12.86 18.2503 9.86995 18.2503 7.16995C18.2503 6.23995 18.0403 5.33995 17.6203 4.47995H17.6103ZM12.1403 7.92995C11.4003 8.26995 10.8003 8.86995 10.4603 9.59995L10.0103 10.57L9.56025 9.59995C9.22025 8.86995 8.62025 8.26995 7.88025 7.92995L6.90025 7.47995L7.88025 7.02995C8.62025 6.68995 9.22025 6.08995 9.56025 5.35995L10.0103 4.38995L10.4603 5.35995C10.8003 6.08995 11.4003 6.68995 12.1403 7.02995L13.1203 7.47995L12.1403 7.92995Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        />
      </g>
    </SvgIcon>
  );
}
